var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
export function getTechPerformanceContext(technicianId, inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get(`/api/internal/ia/technician_assessments/${technicianId}/context`, 
        // eslint-disable-next-line @typescript-eslint/naming-convention, camelcase
        { params: { inspection_id: inspectionId } });
        return response.data;
    });
}
export function getTechnicianScorecard(technicianId, inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield api.get(`/api/internal/ia/technician_assessments/${technicianId}/scorecard`, 
        // eslint-disable-next-line @typescript-eslint/naming-convention, camelcase
        inspectionId === undefined ? undefined : { params: { inspection_id: inspectionId } });
        return response.data;
    });
}
